'use strict';

/* ThreeThing Events: toggling main thumbNail and pinning LeftRail onScroll*/

angular.module('storyApp').factory('threeThingEvents', ['storyProperties', 'storyScroll', function(storyProperties, storyScroll) {
    var threeThingsE = {

        //pin the 3 things left rail below global nav rail when users scroll down
        toggleLeftRailPin: function(scrollYPos) {
            var that = this,
                top = top || storyProperties.secNavHeight + storyProperties.getPromoHeight(),
                sideBar = storyProperties.sideBar,
                hasFixClass = sideBar.classList.contains('fix');

            if (!hasFixClass && scrollYPos >= top) {

                sideBar.classList.add('fix');
                //sideBar.style.transition = 'none';

            } else if (hasFixClass && scrollYPos <= top) {
                //sideBar.style.transition = null;
                sideBar.classList.remove('fix');
            }

            return that;
        },

        //calling toggleLeftRailPin and toggleMainThumbNail
        onEvent: function(viewPort, scrollYPos) {
            //only run following threeThingEvents (pinning 3 things left rail and toggling main story thumbnail on viewport 768 and above
            if (viewPort !== 'mobile') {
                var that = threeThingsE;

                that.toggleLeftRailPin(scrollYPos);
            }
        },


        init: function() {
            var that = this;

            //add to the callback queue that will be hooked in storyScroll onScroll event
            storyScroll.addToQueue(that.onEvent);
        }

    };

    //run this on page load
    threeThingsE.init();


    return threeThingsE;

}]);


// WEBPACK FOOTER //
// ./assets/components/threethings/factories/threeThingEvents.js